
export class FileRow {
rowContent: string;
rowNumber: number | null;
}

